import { createSlice } from '@reduxjs/toolkit';
import {
  cancelWithrawalRequest,
  getAllWalletRequests,
  getAllWalletTransactions,
  getNewWalletTransactions,
  getWalletByUser,
  getWalletDetails,
  getWalletDetailsByUser,
  submitWithrawalRequest,
} from './walletServices';

const initialState = {
  wallet: { balance: 0, currency: '' },
  isLoading: false,
  shouldRefreshWallet: false,

  walletDetails: {
    isLoading: null,
    isSuccess: null,
    walletMessage: null,
    walletDetails: null,
  },

  withdrawalRequest: {
    isRequesting: null,
    isRequestSuccess: null,
    requestMsg: null,
  },

  walletTransactions: {
    isLoadingTransactions: null,
    isTransactionsLoaded: null,
    transactions: [],
  },

   walletRequests: {
    isLoadingRequests: null,
    isRequestLoaded: null,
    requestList: [],
  },

  cancelWithdrawalRequest: {
    isCancelling: null,
    isCancelled: null,
    cancelMsg: null,
  },

  walletTransactions: {
    isTransactionsLoading: null,
    isTransactionsLoaded: null,
    transactions: [],
  },

};

const walletSlice = createSlice({
  name: 'wallet',
  initialState,
  reducers: {
    setShouldRefreshWallet: (state, action) => {
      state.shouldRefreshWallet = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      // Wallet amount
      .addCase(getWalletByUser.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getWalletByUser.fulfilled, (state, action) => {
        state.isLoading = false;
        state.wallet.balance = action.payload.balance;
        state.wallet.currency = action.payload.currency;
        state.shouldRefreshWallet = false;
      })
      .addCase(getWalletByUser.rejected, (state) => {
        state.isLoading = false;
      })

      // Wallet details
      .addCase(getWalletDetailsByUser.pending, (state) => {
        state.walletDetails = {
          ...initialState.walletDetails,
          isLoading: true,
          walletMessage: 'Loading...',
        };
      })
      .addCase(getWalletDetailsByUser.rejected, (state, action) => {
        state.walletDetails = {
          ...initialState.walletDetails,
          isLoading: false,
          isSuccess: false,
          walletMessage: action.payload?.message || 'Failed to load the wallet'
        };
      })
      .addCase(getWalletDetailsByUser.fulfilled, (state, action) => {
        state.walletDetails = {
          ...initialState.walletDetails,
          isLoading: false,
          isSuccess: true,
          walletMessage: action.payload?.message || 'Wallet is loaded',
          walletDetails: action.payload,
        };
      })

      // Withdrawal request
      .addCase(submitWithrawalRequest.pending, (state) => {
        state.withdrawalRequest = {
          ...initialState.withdrawalRequest,
          isRequesting: true,
        };
      })
      .addCase(submitWithrawalRequest.rejected, (state, action) => {
        state.withdrawalRequest = {
          ...initialState.withdrawalRequest,
          isRequesting: false,
          isRequestSuccess: false,
          requestMsg: action.payload?.message || 'Request is failed',
        };
      })
      .addCase(submitWithrawalRequest.fulfilled, (state, action) => {
        state.withdrawalRequest = {
          ...initialState.withdrawalRequest,
          isRequesting: false,
          isRequestSuccess: true,
          requestMsg: action.payload?.message || 'Request is success',
        };
      })

       // Transactions
      .addCase(getAllWalletTransactions.pending, (state) => {
        state.walletTransactions = {
          ...initialState.walletTransactions,
          isLoadingTransactions: true,
        };
      })
      .addCase(getAllWalletTransactions.rejected, (state, action) => {
        state.walletTransactions = {
          ...initialState.walletTransactions,
          isLoadingTransactions: false,
          isTransactionsLoaded: false,
        };
      })
      .addCase(getAllWalletTransactions.fulfilled, (state, action) => {
        state.walletTransactions = {
          ...initialState.walletTransactions,
          isLoadingTransactions: false,
          isTransactionsLoaded: true,
          transactions: action.payload,
        };
      })

       // Requests
      .addCase(getAllWalletRequests.pending, (state) => {
        state.walletRequests = {
          ...initialState.walletRequests,
          isLoadingRequests: true,
        };
      })
      .addCase(getAllWalletRequests.rejected, (state, action) => {
        state.walletRequests = {
          ...initialState.walletRequests,
          isLoadingRequests: false,
          isRequestLoaded: false,
        };
      })
      .addCase(getAllWalletRequests.fulfilled, (state, action) => {
        state.walletRequests = {
          ...initialState.walletRequests,
          isLoadingRequests: false,
          isRequestLoaded: true,
          requestList: action.payload,
        };
      })

       // Cancel Request
      .addCase(cancelWithrawalRequest.pending, (state) => {
        state.cancelWithdrawalRequest = {
          ...initialState.cancelWithdrawalRequest,
          isCancelling: true,
        };
      })
      .addCase(cancelWithrawalRequest.rejected, (state, action) => {
        state.cancelWithdrawalRequest = {
          ...initialState.cancelWithdrawalRequest,
          isCancelling: false,
          isCancelled: false,
          cancelMsg: action.payload.message || 'Failed to cancel the withdrawal request.'
        };
      })
      .addCase(cancelWithrawalRequest.fulfilled, (state, action) => {
        state.cancelWithdrawalRequest = {
          ...initialState.cancelWithdrawalRequest,
          isCancelling: false,
          isCancelled: true,
          cancelMsg: action.payload.message || 'Successfully canceled the withdrawal request.',
        };
      })

      // Wallet transactions
      .addCase(getNewWalletTransactions.pending, (state) => {
        state.walletTransactions = {
          ...initialState.walletTransactions,
          isTransactionsLoading: true,
        };
      })
      .addCase(getNewWalletTransactions.rejected, (state, action) => {
        state.walletTransactions = {
          ...initialState.walletTransactions,
          isTransactionsLoading: false,
          isTransactionsLoaded: false,
        };
      })
      .addCase(getNewWalletTransactions.fulfilled, (state, action) => {
        state.walletTransactions = {
          ...initialState.walletTransactions,
          isTransactionsLoading: false,
          isTransactionsLoaded: true,
          transactions: action.payload,
        };
      })
  },
});

export const { setShouldRefreshWallet } = walletSlice.actions;
export default walletSlice.reducer;
